<template>
  <div>
    <div v-if="loader" class="loader">
      <!-- <b-spinner
        variant="primary"
        type="grow"
        :label="`${this.$t('reports.loadingLabel')}...`"
      ></b-spinner> -->
      <idx-skeleton-chart type="bar" />
    </div>
    <div v-else>
      <highcharts v-if="!isPanel" :options="chartOptions"></highcharts>
      <highcharts
        v-if="isPanel"
        :class="`graph-${idReport}`"
        :id="idReport"
        :options="chartOptions"
      ></highcharts>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import idxSkeletonChart from '@/components/molecules/idx-skeleton-chart';
import eventBus from '../../../../eventBus';

export default {
  name: 'EvolutionNPS',
  props: {
    reportType: {
      type: String,
      default: 'month',
    },
    accumulated: Boolean,
    dataGraph: Object,
    idReport: String,
    w: Number,
    h: Number,
  },
  data: () => ({
    chartOptions: {},
    loader: false,
    selectBoxLoader: false,
    legend: '',
    type: 'column',
    // monthly: false,
    reportTitle: '',
    metricLabel: '',
    chartMax: 100,
    isPanel: false,
  }),

  components: {
    idxSkeletonChart,
  },

  watch: {
    actionGroupData: async function watchActionGroup() {
      // this.prepareChart();
    },
    myActionId: async function watchMyActionId() {
      // this.prepareChart();
    },

    myActionsIds: async function watchMyActionsIds() {
      this.prepareChart();
    },

    myIh1: async function watchMyIh1() {
      // this.prepareChart();
    },

    myIh2: function watchMyIh2() {
      // this.prepareChart();
    },

    calendarDates: function watchDates() {
      this.prepareChart();
    },

    myMetric: function watchMyMetric() {
      // this.changeLabel();
      // this.prepareChart();
    },

    'indicatorData.value': function watchIndicatorData() {
      // this.prepareChart();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      // await this.prepareChart();
    },
  },

  computed: {
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('charts', ['npsEvolution', 'selectIndicators']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },

  methods: {
    ...mapActions('charts', [
      'evolutionDailyNps',
      'evolutionPeriodNps',
      'getIndicatorResults',
    ]),
    ...mapActions('calendar', ['setDefaultDates']),

    async setChartByIndicatorValue() {
      if (this.selectedIndicatorValue) {
        await this.setColumnsPeriod();
      }
    },

    async prepareChart() {
      switch (this.reportType) {
        case 'day':
          if (this.accumulated) {
            this.legend = `- ${this.$t('reports.accDailyLabel')}`;
          } else {
            this.legend = `- ${this.$t('reports.dailyLabel')}`;
          }
          this.setColumnsPeriod();
          break;
        case 'week':
          if (this.accumulated) {
            this.legend = `- ${this.$t('reports.accWeeklyLabel')}`;
          } else {
            this.legend = `- ${this.$t('reports.weeklyLabel')}`;
          }
          this.setColumnsPeriod();
          break;
        case 'month':
          if (this.accumulated) {
            this.legend = `- ${this.$t('reports.accMonthlyLabel')}`;
          } else {
            this.legend = `- ${this.$t('reports.monthlyLabel')}`;
          }
          this.setColumnsPeriod();
          break;
        case 'quarter':
          if (this.accumulated) {
            this.legend = `- ${this.$t('reports.accQuarterlyLabel')}`;
          } else {
            this.legend = `- ${this.$t('reports.quarterlyLabel')}`;
          }
          this.setColumnsPeriod();
          break;
        default:
          this.setColumnsPeriod();
          break;
      }
    },

    // async setColumns() {
    //   this.loader = true;

    //   this.evolutionDailyNps({
    //     companyId: this.userAuth.companyId,
    //     actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
    //     token: this.userAuth.token,
    //     ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
    //     ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
    //     startDate: this.calendarDates.start ? this.calendarDates.start : null,
    //     endDate: this.calendarDates.end ? this.calendarDates.end : null,
    //     metric: this.myMetric ? this.myMetric : null,
    //     indicatorValue: this.indicatorData.value,
    //     indicatorRange: this.indicatorData.range,
    //     indicator: this.indicatorName,
    //     groupId: this.actionGroupData._id,
    //   })
    //     .then(() => {
    //       if (this.accumulated) {
    //         this.renderChart({
    //           categories: this.npsEvolution.categories,
    //           series: this.npsEvolution.seriesAccumulated,
    //         });
    //       } else {
    //         this.renderChart({
    //           categories: this.npsEvolution.categories,
    //           series: this.npsEvolution.series,
    //         });
    //       }

    //       this.loader = false;
    //     })
    //     .catch(() => {
    //       this.loader = false;
    //     });
    // },

    async setColumnsPeriod() {
      this.loader = true;

      this.evolutionPeriodNps({
        companyId: this.userAuth.companyId,
        actionId:this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
        token: this.userAuth.token,
        ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
        ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
        startDate: this.calendarDates.start ? this.calendarDates.start : null,
        endDate: this.calendarDates.end ? this.calendarDates.end : null,
        metric: this.myMetric ? this.myMetric : null,
        indicatorValue: this.indicatorData.value,
        indicatorRange: this.indicatorData.range,
        indicator: this.indicatorName,
        groupId: this.actionGroupData._id,
        reportType: this.reportType,
      })
        .then(() => {
          if (this.accumulated) {
            this.renderChart({
              categories: this.npsEvolution.categories,
              series: this.npsEvolution.seriesAccumulated,
            });
          } else {
            this.renderChart({
              categories: this.npsEvolution.categories,
              series: this.npsEvolution.series,
            });
          }

          this.loader = false;
        })
        .catch(() => {
          this.loader = false;
        });
    },

    async renderChart(data) {
      this.chartOptions = {
        title: {
          align: 'left',
          text: this.isPanel ? '' : `${this.reportTitle} ${this.legend}`,
          style: {
            color: '#5f6368',
          },
        },
        chart: {
          type: this.type,
          height: this.isPanel ? this.h * 45 - 80 : '',
          borderColor: 'rgba(0, 0, 0, 0.09)',
          style: {
            fontFamily:
              '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
            fontSize: '12px',
            width: '100%',
          },
        },
        xAxis: {
          categories: data.categories,
          visible: true,
          labels: {},
        },
        yAxis: {
          gridLineWidth: 0,
          labels: {
            enabled: false,
          },
          max: this.chartMax,
          title: {
            text: '',
          },
          stackLabels: {
            enabled: true,
            fontWeight: 'bold',
          },
        },
        series: [
          {
            name: this.metricLabel,
            data: data.series,
          },
        ],
        legend: {
          enabled: false,
        },
        plotOptions: {
          column: {
            pointPadding: 0.1,
            borderWidth: 0,
            dataLabels: {
              enabled: true,
            },
          },
          line: {
            dataLabels: {
              enabled: true,
            },
          },
          area: {
            dataLabels: {
              enabled: true,
            },
          },
          series: {
            groupPadding: 0,
            pointPadding: 0.05,
            borderWidth: 0,
          },
        },
        colors: ['#4ce595'],
      };
    },

    async chartEmpty() {
      if (this.npsEvolution.categories.length === 0) {
        this.chartOptions = {
          title: {
            align: 'left',
            text: `${this.reportTitle} ${this.legend}`,
            style: {
              color: '#5f6368',
            },
          },
          chart: {
            type: this.type,
            borderColor: 'rgba(0, 0, 0, 0.09)',
            style: {
              fontFamily:
                '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
              fontSize: '12px',
              width: '100%',
            },
          },
        };
      }
    },
    changeLabel() {
      if (this.myMetric.indexOf('nps') !== -1) {
        this.reportTitle = this.$t('reports.basicColumn.reportTitle');
        this.metricLabel = this.$t('reports.npsLabel');
        this.chartMax = 100;
      } else if (this.myMetric.indexOf('ces') !== -1) {
        this.reportTitle = this.$t('reports.basicColumn.cesReportTitle');
        this.metricLabel = this.$t('reports.cesLabel');
        this.chartMax = 5;
      } else if (this.myMetric === 'csat-1-5') {
        this.reportTitle = this.$t('reports.basicColumn.csatReportTitle');
        this.metricLabel = this.$t('reports.csatLabel');
        this.chartMax = 100;
      } else if (this.myMetric === 'csat-1-5(media)' || this.myMetric === 'csat-0-10(media)') {
        this.reportTitle = this.$t(
          'reports.basicColumn.csatAverageReportTitle',
        );
        this.metricLabel = this.$t('reports.csatAverageLabel');
        this.chartMax = 100;
      } else if (this.myMetric === '5-stars') {
        this.reportTitle = this.$t('reports.basicColumn.fiveStarsReportTitle');
        this.metricLabel = this.$t('reports.fiveStarsLabel');
        this.chartMax = 100;
      } else if (this.myMetric === 'like-dislike') {
        this.reportTitle = this.$t(
          'reports.basicColumn.likeDislikeReportTitle',
        );
        this.metricLabel = this.$t('reports.likeDislikeLabel');
        this.chartMax = 2;
      }
    },

    // setColumnCardFilter() {
    //   const $elements = document.querySelectorAll(`.graph-${this.idReport}`);

    //   window.console.log('teste', this.idReport);
    // },

    setColumnCard(data) {
      this.loader = true;

      this.type = data.graph;

      this.evolutionPeriodNps({
        companyId: this.userAuth.companyId,
        actionId: data.actionId ? data.actionId._id : null,
        token: this.userAuth.token,
        ih1: data.ih1 ? data.ih1._id : null,
        period: data.period ? data.period : null,
        // startDate: '2022-01-01',
        // endDate: '2022-07-04',
        reportType: this.reportType,
        metric: data.metric ? data.metric : null,
        indicatorValue: data.valueIndicator ? data.valueIndicator : null,
        indicator: data.indicator ? data.indicator : null,
        groupId: data.actionGroupId ? data.actionGroupId._id : null,
      })
        .then(() => {
          if (this.accumulated) {
            this.renderChart({
              categories: this.npsEvolution.categories,
              series: this.npsEvolution.seriesAccumulated,
            });
          } else {
            this.renderChart({
              categories: this.npsEvolution.categories,
              series: this.npsEvolution.series,
            });
          }

          this.loader = false;
        })
        .catch(() => {
          this.loader = false;
        });
    },

    changeSizeMax() {
      if (this.dataGraph.metric.indexOf('nps') !== -1) {
        this.chartMax = 100;
      } else if (this.dataGraph.metric.indexOf('ces') !== -1) {
        this.chartMax = 5;
        this.metricLabel = this.$t('reports.cesLabel');
      } else if (this.dataGraph.metric === 'csat-1-5') {
        this.metricLabel = this.$t('reports.csatLabel');
        this.chartMax = 100;
      } else if (this.dataGraph.metric === 'csat-1-5(media)' || this.dataGraph.metric === 'csat-0-10(media)') {
        this.reportTitle = this.$t(
          'reports.basicColumn.csatAverageReportTitle',
        );
        this.metricLabel = this.$t('reports.csatAverageLabel');
        this.chartMax = 100;
      } else if (this.dataGraph.metric === '5-stars') {
        this.metricLabel = this.$t('reports.fiveStarsLabel');
        this.chartMax = 100;
      } else if (this.dataGraph.metric === 'like-dislike') {
        this.reportTitle = this.$t(
          'reports.basicColumn.likeDislikeReportTitle',
        );
        this.metricLabel = this.$t('reports.likeDislikeLabel');
        this.chartMax = 2;
      }
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.legend = `- ${this.$t('reports.accDailyLabel')}`;
  },

  async mounted() {
    if (this.$route.fullPath.indexOf('panels') !== -1) {
      this.isPanel = true;
      this.setColumnCard(this.dataGraph);
      this.changeSizeMax();
    } else {
      this.changeLabel();
      this.prepareChart();

      eventBus.$on('accumulated-report', (checked) => {
        this.accumulated = checked;
        switch (checked) {
          case true:
            switch (this.reportType) {
              case 'day':
                this.legend = `- ${this.$t('reports.accDailyLabel')}`;
                break;
              case 'week':
                this.legend = `- ${this.$t('reports.accWeeklyLabel')}`;
                break;
              case 'month':
                this.legend = `- ${this.$t('reports.accMonthlyLabel')}`;
                break;
              case 'quarter':
                this.legend = `- ${this.$t('reports.accQuarterlyLabel')}`;
                break;
              default:
                break;
            }
            this.renderChart({
              categories: this.npsEvolution.categories,
              series: this.npsEvolution.seriesAccumulated,
            });
            break;
          case false:
            switch (this.reportType) {
              case 'day':
                this.legend = `- ${this.$t('reports.dailyLabel')}`;
                break;
              case 'week':
                this.legend = `- ${this.$t('reports.weeklyLabel')}`;
                break;
              case 'month':
                this.legend = `- ${this.$t('reports.monthlyLabel')}`;
                break;
              case 'quarter':
                this.legend = `- ${this.$t('reports.quarterlyLabel')}`;
                break;
              default:
                break;
            }
            this.renderChart({
              categories: this.npsEvolution.categories,
              series: this.npsEvolution.series,
            });
            break;
          default:
            this.legend = ' ';
        }
      });

      eventBus.$on('data-source', (checked) => {
        this.reportType = checked;
        // this.monthly = checked;
        this.prepareChart();
      });

      eventBus.$on('switch-chart', (chart) => {
        this.type = chart;
        this.loader = true;
        if (this.accumulated) {
          this.renderChart({
            categories: this.npsEvolution.categories,
            series: this.npsEvolution.seriesAccumulated,
          });
        } else {
          this.renderChart({
            categories: this.npsEvolution.categories,
            series: this.npsEvolution.series,
          });
        }
        this.loader = false;
      });

      eventBus.$on('apply-filter-menu', () => {
        this.prepareChart();
      })
      eventBus.$on('reset-filter-menu', () => {
        this.prepareChart();
      })
      }
  },

  beforeDestroy() {
    eventBus.$off('switch-chart');
    eventBus.$off('data-source');
    eventBus.$off('accumulated-report');
    eventBus.$off('filter-chart');
    // EventBus.$off('apply-filter-menu');
    // EventBus.$off('reset-filter-menu');
  },
};
</script>

<style lang="scss" scoped>
.loader {
  width: 100%;
  height: 300px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/reports/basicColumn.vue